import './divider.scss';

export const Seperator = () => {
	return <div className="seperator-main"></div>;
};
